import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../../components/Popup";
import {
    closeShipmentItemsEditPopup,
    deleteShipmentItem,
    selectShipmentItemsEditPopup,
    selectShipmentItemsUpdatingStatus,
    setShipmentItemsEditPopupData,
    updateShipmentItem,
} from "../ShipmentItems/shipmentItemsSlice";

import style from "../../../sass/components/popups/shipment-item-popup.module.scss";
import { Button } from "@mui/material";
import { selectShipment } from "../shipmentSlice";
import SelectProductType from "../../productTypeSelect/SelectProductType";
import { STANDARD_PACKAGE_TYPE, countryCodes } from "../../../data/static-data";
import { ValidateWeight, validateEnName, validateGtipCode, validateItemsCount, validateMarketLink, validatePrice, validateOriginalName, validateShipmentItem, validateTrName } from "../../../validators/validateShipmentItem";
import { pushAlert } from "../../alerts/alertSlice";
import { useTranslation } from "react-i18next";

const initialState = {
    "en-name": "",
    "tr-name": "",
    "original-name": "",
    "gtip-code": "",
    "item-code": "11111",
    link: "",
    "value-for-one": "",
    count: "",
    warning: false,
    "country-code": "",
};
const initialErrorState = {
    "tr-name": "",
    "original-name": "",
    "en-name": "",
    "gtip-code": "",
    link: "",
    "value-for-one": "",
    count: "",
    warning: "",
    "country-code": "",
};

const EditShipmentItemPopup = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const popupState = useSelector(selectShipmentItemsEditPopup);
    const shipment = useSelector(selectShipment);

    const [state, setState] = useState({ ...initialState });
    const [errors, setErrors] = useState({ ...initialErrorState });
    const [productType, setProductType] = useState(null);
    const itemsUpdatingStatus = useSelector(selectShipmentItemsUpdatingStatus);

    const setTrName = (value) => {
        setState((prev) => ({ ...prev, "tr-name": value }));
        let validationResult = validateTrName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "tr-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "tr-name": "",
            }));
        }
    };
    const setEnName = (value) => {
        setState((prev) => ({ ...prev, "en-name": value }));
        let validationResult = validateEnName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "en-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "en-name": "",
            }));
        }
    };
    const setOriginalName = (value) => {
        setState((prev) => ({ ...prev, "original-name": value }));
        let validationResult = validateOriginalName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "original-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "original-name": "",
            }));
        }
    };
    const setGtipCode = (value) => {
        if(value.length > 4) return
        
        setState((prev) => ({ ...prev, "gtip-code": value }));
        let validationResult = validateGtipCode(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "gtip-code": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "gtip-code": "",
            }));
        }
    };
    const setLink = (value) => {
        setState((prev) => ({ ...prev, "link": value }));
        let validationResult = validateMarketLink(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "link": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "link": "",
            }));
        }
    };
    const setValueForOne = (value) => {
        setState((prev) => ({ ...prev, "value-for-one": value }));
        let validationResult = validatePrice(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "value-for-one": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "value-for-one": "",
            }));
        }
    };
    const setCount = (value) => {
        setState((prev) => ({ ...prev, "count": value }));
        let validationResult = validateItemsCount(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "count": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "count": "",
            }));
        }
    };
    const setCountryCode = (value) => {
        setState((prev) => ({ ...prev, "country-code": value }));
    };

    //on changing popup data in redux state (for example clicking on tr name link)
    useEffect(() => {
        setErrors({ ...initialErrorState });

        if (!popupState.data) {
            setState({ ...initialState });
            return;
        }
        setState({
            "en-name": popupState.data["en-name"] ?? "",
            "tr-name": popupState.data["tr-name"] ?? "",
            "original-name": popupState.data["original-name"] ?? "",
            "gtip-code": popupState.data["gtip-code"] ?? "",
            "item-code": popupState.data["item-code"] ?? "",
            "value-for-one": popupState.data["value-for-one"] ?? "",
            count: popupState.data["count"] ?? "",
            link: popupState.data["link"] ?? "",
            warning: popupState.data["warning"] ?? false,
            "country-code": popupState.data["country-code"] ?? false,
        });
    }, [popupState.data]);

    useEffect(() => {
        if (productType) {
            setState((prev) => ({
                ...prev,
                ...productType
            })
            );
            setErrors({ ...initialErrorState });
        }
    }, [productType])

    
    const closePopup = () => {
        setProductType(null)
        dispatch(closeShipmentItemsEditPopup());
        dispatch(
            setShipmentItemsEditPopupData({
                data: null,
            })
        );
    };

    useEffect(() => {
        if (itemsUpdatingStatus === "fulfilled") {
            setProductType(null)
        }
    }, [dispatch, itemsUpdatingStatus]);

    const handleButtonClick = () => {
        if (!shipment?.id || !popupState.boxID) {
            console.log("wtf");
            return false;
        }
        console.log(state)

        let errors = validateShipmentItem(state)
        if(errors && errors.length > 0) {
            errors.forEach((error) => {
                dispatch(pushAlert({
                    type: "danger",
                    message: t(error),
                    delay: 2000
                }))
            })
            return
        }


        dispatch(
            updateShipmentItem({
                data: state,
                shipmentID: shipment.id,
                shipmentItemID: popupState.data.id,
                boxID: popupState.boxID,
            })
        );
    };


    const handleDeleteButtonClick = () => {
        if (!shipment?.id || !popupState.boxID) {
            console.log("wtf");
            return false;
        }

        dispatch(
            deleteShipmentItem({
                boxID: popupState.boxID,
                shipmentID: shipment.id,
                shipmentItemID: popupState.data.id,
            })
        );
    };

    return (
        <Popup opened={popupState.opened} closeCallback={closePopup}>
            <header className="text-xl text-emerald-600 text-left mb-3">
                {t("shipment.items.item_popup.edit_title")}
            </header>

            <form className="flex flex-col gap-4 mb-4 text-left">
                {/* MARKET LINK */}
                {shipment && shipment["package-type"] === STANDARD_PACKAGE_TYPE && (
                    <div className="flex flex-col gap items-start">
                        <span className="text-xs text-gray-600">
                            {t("shipment.items.item_popup.link.title")}
                        </span>
                        <input
                            className={style.input}
                            placeholder={t("shipment.items.item_popup.link.placeholder")}
                            value={state["link"]}
                            onInput={(e) => setLink(e.target.value)}
                            type="text"
                        />
                        {errors["link"] && (
                            <div className={style.error}>{errors["link"]}</div>
                        )}
                    </div>
                )}
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.original_name.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.original_name.placeholder")}
                        value={state["original-name"]}
                        onInput={(e) => setOriginalName(e.target.value)}
                        type="text"
                    />
                    {errors["original-name"] && (
                        <div className={style.error}>{errors["original-name"]}</div>
                    )}
                </div>
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.value_for_one.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.value_for_one.placeholder")}
                        value={state["value-for-one"]}
                        onInput={(e) => setValueForOne(e.target.value)}
                        type="text"
                    />
                    {errors["value-for-one"] && (
                        <div className={style.error}>
                            {errors["value-for-one"]}
                        </div>
                    )}
                </div>
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.count.title")}
                    </span>
                    <input
                        className="border text-2xs px-2 w-28"
                        placeholder={t("shipment.items.item_popup.count.placeholder")}
                        value={state["count"]}
                        onInput={(e) => setCount(e.target.value)}
                        type="number"
                    />
                    {errors["count"] && (
                        <div className={style.error}>{errors["count"]}</div>
                    )}
                </div>
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.origin_country.title")}
                    </span>
                    <select
                        className={`${style.select}`}
                        value={state["country-code"]}
                        onChange={(e) => setCountryCode(e.target.value)}
                    >
                        <option value="" className='hidden'></option>
                        {countryCodes.map((country, index) => (
                            <option key={index} value={country.value}>
                                {country.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-col gap items-start">
                    <div className="flex justify-start items-center gap-2">
                        <span className="text-xs text-gray-600">
                            {t("shipment.items.item_popup.warning.title")}
                        </span>
                        <input
                            className={`${style.checkbox} h-4 w-4`}
                            type="checkbox"
                            checked={state.warning}
                            onChange={(e) =>
                                setState((prev) => ({
                                    ...prev,
                                    warning: !state.warning,
                                }))
                            }
                        />
                    </div>
                </div>

                <SelectProductType setState={setProductType} state={productType}/>
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.tr_name.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.tr_name.placeholder")}
                        value={state["tr-name"]}
                        onInput={(e) => setTrName(e.target.value)}
                        type="text"
                    />
                    {errors["tr-name"] && (
                        <div className={style.error}>{errors["tr-name"]}</div>
                    )}
                </div>
                
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.en_name.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.en_name.placeholder")}
                        value={state["en-name"]}
                        onInput={(e) => setEnName(e.target.value)}
                        type="text"
                    />
                    {errors["en-name"] && (
                        <div className={style.error}>{errors["en-name"]}</div>
                    )}
                </div>
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.gtip_code.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.gtip_code.placeholder")}
                        value={state["gtip-code"]}
                        onInput={(e) => setGtipCode(e.target.value)}
                        type="text"
                    />
                    {errors["gtip-code"] && (
                        <div className={style.error}>{errors["gtip-code"]}</div>
                    )}
                </div>

                
            </form>

            <div className="mb-2">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                        ":focus": {
                            bgcolor: "#047857",
                        },
                    }}
                    className="w-10/12"
                    onClick={handleButtonClick}
                >
                    {t("shipment.items.item_popup.save_button")}
                </Button>
            </div>

            <Button
                variant="contained"
                sx={{
                    color: "white",
                    bgcolor: "#dc2626",
                    fontSize: "0.7rem",
                    ":hover": {
                        bgcolor: "#b91c1c",
                    },
                    ":focus": {
                        bgcolor: "#b91c1c",
                    },
                }}
                className="w-10/12 block mb-4"
                onClick={handleDeleteButtonClick}
            >
                {t("shipment.items.item_popup.delete_button")}
            </Button>
        </Popup>
    );
};

export default EditShipmentItemPopup;
